import { supabase } from './supabase';

export const generateResponse = async (messages: { role: string; content: string }[], assistantId: string) => {
  try {
    // Check internet connection
    if (!navigator.onLine) {
      throw new Error('Sem conexão com a internet. Verifique sua conexão e tente novamente.');
    }

    // Get user's most recent chat
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data: chats, error: chatError } = await supabase
      .from('chats')
      .select('id')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false })
      .limit(1);

    if (chatError) throw chatError;
    if (!chats?.length) throw new Error('No chat found');

    const chatId = chats[0].id;

    const response = await fetch('https://crieai.app.n8n.cloud/webhook/c3282ace-58b6-4216-ad8a-51e770717757', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin
      },
      body: JSON.stringify({
        text: messages[messages.length - 1].content,
        chatId: chatId
      })
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Endpoint não encontrado. Por favor, verifique a URL do servidor.');
      }
      throw new Error(`Erro do servidor: ${response.status}`);
    }

    const data = await response.json();
    return data.output || "Olá! Como posso ajudar você hoje?";

  } catch (error) {
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      throw new Error('Não foi possível conectar ao servidor. Verifique sua conexão ou tente novamente mais tarde.');
    }
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Erro inesperado ao processar mensagem');
  }
};